// extracted by mini-css-extract-plugin
export default {"container":"ModularConfigurationPurchaseActions__container___chynU","requestQuoteLink":"ModularConfigurationPurchaseActions__requestQuoteLink___L9t78"};